import React from 'react';
import { format } from 'date-fns';
import clsx from 'clsx';
import { CreditHistory } from 'entity/reward/rewardTypes';
import useIsMobile from 'utils/hooks/useIsMobile';

const CreditHistoryCard = (props: {
  creditHistory: CreditHistory;
  type: 'debit' | 'credit';
}) => {
  const isMobile = useIsMobile();

  const { creditHistory, type } = props;
  const { amount, subdescription, description, createdAt } = creditHistory;
  const createdDate = new Date(createdAt);
  const amountText = `${
    type === 'debit' ? '-' : '+'
  } ${amount?.toLocaleString()}`;

  return (
    <div className="border border-neutral-400 p-3 rounded-lg w-full">
      <div className="flex justify-between w-full items-center">
        <div className="flex flex-col gap-1">
          <p className={clsx(isMobile && 'text-xs text-neutral-500')}>
            {format(createdDate, 'd MMM yyyy')}
          </p>
          <p className="text-sm font-bold">{description}</p>
          {subdescription && (
            <p className={clsx(isMobile && 'text-xs text-neutral-500')}>
              {subdescription}
            </p>
          )}
        </div>
        <p
          className={clsx(
            isMobile ? 'text-sm font-bold' : 'text-xl font-bold',
            type === 'debit' ? 'text-red-500' : 'text-green-600',
          )}
        >
          {amountText}
        </p>
      </div>
    </div>
  );
};

export default CreditHistoryCard;
